import React from 'react';

import { Flex, Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { FilterBlock, IField, IInputFilterValue } from '@components/FilterBlock';
import { UserStatus } from '@components/Status/components/UserStatus';

export const ACTIVE_FILTER_VALUE = 'true';
export const DISABLED_FILTER_VALUE = 'false';

interface IProps {
  onChange: (value: string) => void;
}

interface IUserStatusFilterProps {
  value?: IInputFilterValue;
  onChange?: (value?: IInputFilterValue) => void;
}

const UserStatusFilterSelect = React.forwardRef<any, IUserStatusFilterProps>(({ value, onChange, ...props }, ref) => (
  <Select
    ref={ref}
    allowClear
    value={value?.value}
    style={{ minWidth: 180 }}
    options={[
      { value: ACTIVE_FILTER_VALUE, label: <UserStatus isActive /> },
      { value: DISABLED_FILTER_VALUE, label: <UserStatus isActive={false} /> },
    ]}
    onChange={(nextValue) => onChange?.(nextValue ? { value: nextValue } : undefined)}
    {...props}
  />
));

UserStatusFilterSelect.displayName = 'UserStatusFilterSelect';

export const Filters: React.FC<IProps> = ({ onChange }) => {
  const employeesT = useTranslation(NSKeys.employees);

  const filters = React.useMemo<IField[]>(
    () => [
      {
        label: employeesT.t('tableColumns.status'),
        name: 'is_active',
        inputField: <UserStatusFilterSelect />,
        renderDisplayValue: (value: IInputFilterValue) => (
          <UserStatus isActive={value?.value === ACTIVE_FILTER_VALUE} />
        ),
      },
    ],
    [employeesT.t]
  );

  return (
    <Flex justify="flex-end" style={{ marginBottom: 24 }}>
      <FilterBlock
        uidPrefix="employees-list"
        fields={filters}
        showSearchField={false}
        requiredSearchField={false}
        onSubmit={onChange}
        initialValues={{}}
      />
    </Flex>
  );
};
